<template>
  <div class="animated fadeIn">
    <br />
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Pólizas Nuevas</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>

          <b-row class="my-1">
            <b-col sm="2">
              <label style="text-aling: rigth">Año</label>
            </b-col>
            <b-col sm="2">
              <b-form-input
                  type="number"
                  v-model="datosFormulario.ano"
                >
                </b-form-input>
              <span class="error-validacion-campo">{{
                mensajeValidacionCampo.ano
              }}</span>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="2">
              <label style="text-aling: rigth">Ejecutivo/Asistente</label>
            </b-col>
            <b-col sm="2">
              <b-form-select
                :options="ejecutivos"
                v-model="datosFormulario.ejecutivo"
              >
              </b-form-select>
              <span class="error-validacion-campo">{{
                mensajeValidacionCampo.ejecutivo
              }}</span>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="2">
              <label>Póliza</label>
            </b-col>
            <b-col sm="2">
              <!-- <b-form-group> -->
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="datosFormulario.poliza"
                  @change="consulta_poliza()"
                >
                </b-form-input>
                <b-input-group-prepend class="input-group-append">
                  <b-button
                    type="submit"
                    class="fa fa-search"
                    variant="primary"
                  ></b-button>
                </b-input-group-prepend>
              </b-input-group>
              <span class="error-validacion-campo">
                {{ mensajeValidacionCampo.poliza }}
              </span>
              <!-- </b-form-group> -->
            </b-col>
          </b-row>

          <b-row class="my-1">
              <b-col sm="2">
                <label>Contratante</label>
              </b-col>
              <b-col sm="2">
                <b-form  @submit.prevent="consulta_contratante()" >
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.contratante"
                  @change="validarCampo('contratante', 'contratante', $event, 'datosFormulario.contratante');consulta_contratante()"/>
                  <b-input-group-prepend class="input-group-append">
                      <b-button type="submit" class="fa fa-search" variant="primary"></b-button>
                  </b-input-group-prepend>
                </b-input-group>
                </b-form>
              </b-col>
              <b-col sm ="2">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.IdNacionAse"/>
                </b-input-group>
              </b-col>
              <b-col sm="5">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.NombreAseg"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm = "2">
                <label>Corredor</label>
              </b-col>
              <b-col sm = "2">
                <b-form  @submit.prevent="consulta_corredor()" >
                  <b-input-group @submit.prevent="consulta_corredor()">
                    <b-form-input type="text" v-model="datosFormulario.corredor"/>
                    <b-input-group-prepend class="input-group-append">
                        <b-button type="submit" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form>
              </b-col>
              <b-col sm = "2">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.IdNacionCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="5">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.NombreCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row>

          <b-row class="my-1">
            <b-col sm="2">
              <label style="text-aling: rigth">Producto</label>
            </b-col>
            <b-col sm="2">
              <b-form-select
                :options="productos"
                v-model="datosFormulario.producto"
              >
              </b-form-select>
              <span class="error-validacion-campo">{{
                mensajeValidacionCampo.producto
              }}</span>
            </b-col>
          </b-row>

          <div slot="footer">
            <div class="form-actions text-right">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar"
                    ><i class="fa fa-search"></i> Consultar</b-button
                  >
                  <b-button
                    variant="primary"
                    @click="pre_insertar"
                    style="margin-left: 10px"
                    ><i class="fa fa-eraser"></i> Limpiar</b-button
                  >
                  <b-button variant="primary" @click="descargarExcel" v-show="exportar" style="margin-left: 10px"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>


        <b-card v-if="tieneAcceso === true" v-show="data != ''? true : false">
          <div slot="header">
            <strong>Pólizas Nuevas</strong>
          </div>
          <b-row>
            <b-col lg="6">

            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  prop = "semestre"
                  min-width = "120"
                  label = "Semestre"
                  key= "Semestre"
                  align= "left"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "codcontratante"
                  min-width = "100"
                  label = "Código Contratante"
                  key= "Codcontratante"
                  align= "left"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "contratante"
                  min-width = "300"
                  label = "Contratante"
                  key= "Contratante"
                  align= "left"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "poliza"
                  min-width = "80"
                  label = "Póliza"
                  key= "Póliza"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "producto"
                  min-width = "120"
                  label = "Producto"
                  key= "Producto"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "corredor"
                  min-width = "300"
                  label = "Corredor"
                  key= "Corredor"
                  align= "left"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "fechaemision"
                  min-width = "120"
                  label = "Fecha Emisión"
                  key= "Fecha Emisión"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "pagador"
                  min-width = "120"
                  label = "Pagador"
                  key= "Pagador"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "ejecutivo_1er"
                  min-width = "200"
                  label = "Ejecutivo 1er Contacto"
                  key= "Ejecutivo 1er Contacto"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "ejecutivo_cierre"
                  min-width = "200"
                  label = "Ejecutivo Cierre Negocio"
                  key= "Ejecutivo Cierre Negocio"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "moneda"
                  min-width = "120"
                  label = "Moneda Póliza"
                  key= "Moneda Póliza"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "montoaseg_a"
                  min-width = "250"
                  label = "Monto Asegurado Moneda Póliza"
                  key= "Monto Asegurado Moneda Póliza"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "montoaseg_b"
                  min-width = "200"
                  label = "Monto Asegurado US"
                  key= "Monto Asegurado US"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  v-if="isChile" 
                  prop = "montoaseg_c"
                  min-width = "200"
                  label = "Monto Asegurado UF"
                  key= "Monto Asegurado UF"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                 <el-table-column
                  v-if="isPeru"
                  prop = "montoaseg_c"
                  min-width = "200"
                  label = "Monto Asegurado S/"
                  key= "Monto Asegurado S/"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                 <el-table-column
                  v-if="isArge"
                  prop = "montoaseg_c"
                  min-width = "200"
                  label = "Monto Asegurado $"
                  key= "Monto Asegurado $"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "tasa"
                  min-width = "150"
                  label = "Tasa"
                  key= "Tasa"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "prima_a"
                  min-width = "200"
                  label = "Prima Moneda Póliza"
                  key= "Prima Moneda Póliza"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "prima_b"
                  min-width = "150"
                  label = "Prima US"
                  key= "Prima US"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  v-if="isChile"
                  prop = "prima_c"
                  min-width = "150"
                  label = "Prima UF"
                  key= "Prima UF"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  v-if="isPeru"
                  prop = "prima_c"
                  min-width = "150"
                  label = "Prima S/"
                  key= "Prima S/"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  v-if="isArge"
                  prop = "prima_c"
                  min-width = "150"
                  label = "Prima $"
                  key= "Prima $"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  v-if="isChile"
                  prop = "consulta_pep"
                  min-width = "150"
                  label = "Consulta PEP"
                  key= "Consulta PEP"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  v-if="isChile"
                  prop = "ingreso_dbf"
                  min-width = "150"
                  label = "Ingreso DBF"
                  key= "Ingreso DBF"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "relacionada"
                  min-width = "300"
                  label = "Relacionada a"
                  key= "Relacionada a"
                  align= "left"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "observacion"
                  min-width = "300"
                  label = "Observación"
                  key= "Observación"
                  align= "left"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>

                <el-table-column label="Acción" min-width="150px" align="center">
                <template slot-scope="scope">
                    <el-button
                          type="text"
                          size="mini"
                          @click="button.handler"
                          v-for="button in customButtonsForRow(scope.row)"
                          :key="button.id"
                        >
                          {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>

              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <!-- Detalle -->
    <b-modal
      title="Modificar"
      class="modal-success"
      v-model="modalModificar"
      cancel-title="Cerrar"
      ok-title="Guardar"
      @ok="actualizaEjecutivoObs();"
      @cancel="modalModificar = false"
    >
          <b-row class="my-1">
            <b-col sm="4">
              <label style="text-aling: rigth">Relacionada a</label>
            </b-col>
            <b-col sm="8">
              <b-form-textarea
                  v-model="datosFormularioModal.relacionada"
                  rows="3"
                  max-rows="3"
                ></b-form-textarea>
              <span class="error-validacion-campo">{{
                mensajeValidacionCampo.relacionada
              }}</span>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="4">
              <label style="text-aling: rigth">Observación</label>
            </b-col>
            <b-col sm="8">
              <b-form-textarea
                  v-model="datosFormularioModal.observacion"
                  rows="3"
                  max-rows="3"
                ></b-form-textarea>
              <span class="error-validacion-campo">{{
                mensajeValidacionCampo.observacion
              }}</span>
            </b-col>
          </b-row>




    </b-modal>


      </b-col>
    </b-row>

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiGestionVentas from "@/components/services/apiGestionVentas";
import apiBaseAsegurado from "@/components/services/apiBaseAsegurado";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";
import Multiselect from "vue-multiselect";

import XLSX from "xlsx";

export default {
  name: "PolizasNuevas",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
  },
  data: function () {
    return {
      isChile: false,
      isPeru: false,
      isArge: false,
      hasPoliza: false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },
      selectedCor: [],
      selectedDire: [],

      modalModificar: false,

      data: [],
      nombreexcel: "PolizasNuevas.xls",

      titles: [
        {
          prop: "semestre",
          label: "Semestre",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "codcontratante",
          label: "Código Contratante",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "contratante",
          label: "Contratante",
          align: "center",
          minwidth: "80",
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "producto",
          label: "Producto",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "corredor",
          label: "Corredor",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "fechaemision",
          label: "Fecha Emisión",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "pagador",
          label: "Pagador",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "ejecutivo_1er",
          label: "Ejecutivo 1er Contacto",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "ejecutivo_cierre",
          label: "Ejecutivo Cierre Negocio",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "moneda",
          label: "Moneda Póliza",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "montoaseg_a",
          label: "Monto Asegurado Moneda Póliza",
          align: "right",
          minwidth: "180",
        },
        {
          prop: "montoaseg_b",
          label: "Montos Asegurado US",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "montoaseg_c",
          label: "Monto Asegurado UF",
          align: "right",
          minwidth: "150",
        }, 
        {
          prop: "tasa",
          label: "Tasa",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "prima_a",
          label: "Prima Moneda Póliza",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "prima_b",
          label: "Prima US",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "prima_c",
          label: "Prima UF",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "consulta_pep",
          label: "Consulta PEP",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "ingreso_dbf",
          label: "Ingreso DBF",
          align: "center",
          minwidth: "70",
        },
                {
          prop: "relacionada",
          label: "Relacionada a",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "observacion",
          label: "Observación",
          align: "center",
          minwidth: "70",
        },
      ],

    titles2: [
        {
          prop: "semestre",
          label: "Semestre",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "codcontratante",
          label: "Código Contratante",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "contratante",
          label: "Contratante",
          align: "center",
          minwidth: "80",
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "producto",
          label: "Producto",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "corredor",
          label: "Corredor",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "fechaemision",
          label: "Fecha Emisión",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "pagador",
          label: "Pagador",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "ejecutivo_1er",
          label: "Ejecutivo 1er Contacto",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "ejecutivo_cierre",
          label: "Ejecutivo Cierre Negocio",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "moneda",
          label: "Moneda Póliza",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "montoaseg_a",
          label: "Monto Asegurado Moneda Póliza",
          align: "right",
          minwidth: "180",
        },
        {
          prop: "montoaseg_b",
          label: "Montos Asegurado US",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "montoaseg_c",
          label: "Monto Asegurado S/",
          align: "right",
          minwidth: "150",
        },
        {
          prop: "tasa",
          label: "Tasa",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "prima_a",
          label: "Prima Moneda Póliza",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "prima_b",
          label: "Prima US",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "prima_c",
          label: "Prima S/",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "relacionada",
          label: "Relacionada a",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "observacion",
          label: "Observación",
          align: "center",
          minwidth: "70",
        },
      ],

    titles3: [
        {
          prop: "semestre",
          label: "Semestre",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "codcontratante",
          label: "Código Contratante",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "contratante",
          label: "Contratante",
          align: "center",
          minwidth: "80",
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "producto",
          label: "Producto",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "corredor",
          label: "Corredor",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "fechaemision",
          label: "Fecha Emisión",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "pagador",
          label: "Pagador",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "ejecutivo_1er",
          label: "Ejecutivo 1er Contacto",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "ejecutivo_cierre",
          label: "Ejecutivo Cierre Negocio",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "moneda",
          label: "Moneda Póliza",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "montoaseg_a",
          label: "Monto Asegurado Moneda Póliza",
          align: "right",
          minwidth: "180",
        },
        {
          prop: "montoaseg_b",
          label: "Montos Asegurado US",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "montoaseg_c",
          label: "Monto Asegurado $",
          align: "right",
          minwidth: "150",
        },
        {
          prop: "tasa",
          label: "Tasa",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "prima_a",
          label: "Prima Moneda Póliza",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "prima_b",
          label: "Prima US",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "prima_c",
          label: "Prima $",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "relacionada",
          label: "Relacionada a",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "observacion",
          label: "Observación",
          align: "center",
          minwidth: "70",
        },
      ],

      titlesDinamic: [],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              console.log(prop);
              if (prop === 'fechaemision'){

                let elDate = new Date(row["fechaemision"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }

              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }

            })

          }
        }
      ],

      mostrarFechas: true,

      datosFormulario: {
          ejecutivo:"",
          poliza:"",
          ano:"",
          producto: "",
          contratante: "",
          corredor: "",

          IdNacionAse: "",
          NombreAseg: "",

          IdNacionCorred: "",
          NombreCorred: "",

          valor_monereaj: 0,
          valor_peso: 0,
          valor_eu: 0,
          valor_us: 0
      },

      datosFormularioModal: {
          poliza:"",
          ejecutivo_1er: "",
          ejecutivo_cierre: "",
          observacion: "",
          relacionada: ""
      },

      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      ejecutivos: [],
      productos: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        //rowKey: "poliza",
      },
    };
  },
  components: {
    Datepicker,
    Multiselect,
  },
  methods: {

    customButtonsForRow(row) {
          var botones = new Array();

          var obj = new Object();
            obj.tooltip = "Modificar";
            obj.id = 1;
            obj.name= "Modificar";
            obj.icon = "fa fa-edit";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                this.modificar(row);
            }
            botones.push(obj);


          return botones;

    },

    modificar(row) {
      console.log(row);
      this.datosFormularioModal.poliza = row.poliza;
      this.datosFormularioModal.ejecutivo_1er = row.ejecutivo_1er;
      this.datosFormularioModal.ejecutivo_cierre = row.ejecutivo_cierre;
      this.datosFormularioModal.observacion = row.observacion;
      this.datosFormularioModal.relacionada = row.relacionada;
      this.modalModificar = true;
    },

    llenaArrayLista(data, valor, texto, isDate) {
      var arr = new Array();
      for (var i = 0; i < data.length; i++) {
        var obj = new Object();
        if (isDate) {
          obj.value = this.convierteFecha(data[i][valor]);
          obj.text = this.convierteFecha(data[i][texto]);
        } else {
          obj.value = data[i][valor].toString();
          obj.text = data[i][texto];
        }
        arr.push(obj);
      }
      return arr;
    },

    pre_insertar() {
      this.$Progress.start();
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      this.datosFormulario.ejecutivo = "T";
      this.datosFormulario.poliza = "";
      this.datosFormulario.ano = null;
      this.datosFormulario.contratante = "";
      this.datosFormulario.corredor = "";
      this.datosFormulario.producto = "T";

      this.datosFormulario.IdNacionAse = "";
      this.datosFormulario.NombreAseg = "";
      this.datosFormulario.IdNacionCorred = "";
      this.datosFormulario.NombreCorred =  "";

      this.hasPoliza = false;

      return apiGestionVentas
        .pre_insercion_pol_nue(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);

          if (response.data.res[0].codpais == 'CL'){
            this.isChile = true;
          }

          if (response.data.res[0].codpais == 'PE'){
            this.isPeru = true;
          }

          if (response.data.res[0].codpais == 'AR'){
            this.isArge = true;
          }

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == "s") {
            this.tieneAcceso = true;
          } else {
            this.tieneAcceso = false;
          }         

          this.datosFormulario.ano = response.data.res[0].hoy;

          //carga de listados
          this.ejecutivos = this.llenaArrayLista(response.data.ejecutivos, 'codigo', 'nombre', false);
          this.productos = this.llenaArrayLista(response.data.productos, 'codigo', 'nombre', false);

          //Carga de listados todos
          var obj = new Object();
          obj.value = "T";
          obj.text = "Todos";
          this.ejecutivos.push(obj);
          this.productos.push(obj);

          this.datosFormularioEstado = response.data.festado;

          this.$Progress.finish();
        })
        .catch((error) => {
          this.$Progress.finish();
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();
      this.exportar = false;
      return apiGestionVentas
        .recuperar_pol_nue(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.ano,
          this.datosFormulario.poliza == ""? 0 : this.datosFormulario.poliza,
          this.datosFormulario.ejecutivo,
          this.datosFormulario.corredor == ""? 0 : this.datosFormulario.corredor,
          this.datosFormulario.producto,
          this.datosFormulario.contratante == ""? 0 : this.datosFormulario.contratante)
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          this.data = response.data.res;

          if (this.data != null){
            this.exportar = true;
          } else {
            this.exportar = false;
          }
          this.datosFormulario.valor_monereaj = response.data.res2[0].valor_monereaj;
          this.datosFormulario.valor_peso = response.data.res2[0].valor_peso;
          this.datosFormulario.valor_eu = response.data.res2[0].valor_eu;
          this.datosFormulario.valor_us = response.data.res2[0].valor_us;

          this.$Progress.finish();
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    formatter(row, column) {
      if ((column.property == "fechaemision") && row[column.property]) {
        return this.configurarFechaLat(
          this.convierteFecha(row[column.property])
        );
      } else if ((column.property == "montoaseg_a" || column.property == "montoaseg_b" || column.property == "montoaseg_c" || column.property == "prima_a" || column.property == "prima_b" || column.property == "prima_c") && row[column.property]) {
        if (row[column.property] == -1 || row[column.property] == "-1"){
          return "N/A";
        }
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else if (column.property == "costo_variable_minimo" && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0");
        }
      } else {
        return row[column.property];
      }
    },

    descargarExcel: function () {
      var cuerpo = "";
      if (this.isChile) {
      var columnas = this.titles; 
      }
      else if (this.isPeru) {
      var columnas = this.titles2;
      }
      else {
        var columnas = this.titles3;
      };

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";


      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'> Tipo de Cambio 01/01/" + this.datosFormulario.ano + "</td>\n";
      if (this.isChile) {
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "mso-number-format:\"\@\"''> UF " + this.$numeral(this.datosFormulario.valor_monereaj).format("0,0.00") + "</td>\n";};
      if (this.isPeru) {
           cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "mso-number-format:\"\@\"''> S/ " + this.$numeral(this.datosFormulario.valor_monereaj).format("0,0.00") + "</td>\n";};
      if (this.isArge) {
           cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "mso-number-format:\"\@\"''> $ " + this.$numeral(this.datosFormulario.valor_monereaj).format("0,0.00") + "</td>\n";};   
      cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "mso-number-format:\"\@\"''> US " + this.$numeral(this.datosFormulario.valor_us).format("0,0.00") + "</td>\n";
      cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "mso-number-format:\"\@\"''> EU " + this.$numeral(this.datosFormulario.valor_eu).format("0,0.00") + "</td>\n";
      cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "mso-number-format:\"\@\"''> $ " + this.$numeral(this.datosFormulario.valor_peso).format("0,0.00") + "</td>\n";
      cuerpo += "</tr>\n";


      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";

      //Data bloque 1
      for (var key in this.data) {

        if(this.data[key]["observacion"] == undefined){
          this.data[key]["observacion"] = "";
        }
        if(this.data[key]["relacionada"] == undefined){
          this.data[key]["relacionada"] = "";
        }

        
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["semestre"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["codcontratante"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["contratante"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["producto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["corredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["fechaemision"])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["pagador"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ejecutivo_1er"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ejecutivo_cierre"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["moneda"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["montoaseg_a"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["montoaseg_b"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["montoaseg_c"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+ this.data[key]["tasa"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["prima_a"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["prima_b"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["prima_c"]).format("0,0.00") + "</td>\n";
        if (this.isChile) {
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["consulta_pep"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ingreso_dbf"] + "</td>\n";
        };
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["relacionada"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["observacion"] + "</td>\n";
        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },

    consulta_poliza: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasPoliza = false;

      return apiGestionVentas
        .consulta_poliza(
          this.$session.get("mail"),
          this.datosFormulario.ejecutivo,
          this.datosFormulario.poliza == ''? 0 : this.datosFormulario.poliza
        ).then((response) => {
          response.data = this.keysMinuscula(response.data);

          var Listapoliza = response.data.res;
          for (var i = 0; i < Listapoliza.length; i++) {
            this.datosFormulario.poliza       = Listapoliza[i]["marpoliza"];
            this.datosFormulario.contratante  = Listapoliza[i]["marcontratante"];
            this.datosFormulario.producto     = Listapoliza[i]["marproducto"];
            this.datosFormulario.NombreAseg   = Listapoliza[i]["nomcontratante"];
            this.datosFormulario.corredor     = Listapoliza[i]["marcorredor"];
            this.datosFormulario.NombreCorred = Listapoliza[i]["nomcorredor"];
            this.datosFormulario.ano          = Listapoliza[i]["anoemision"];
            this.datosFormulario.ejecutivo    = Listapoliza[i]["ejecutivo"];
            this.hasPoliza = true;
          }
          this.consulta_contratante();
          this.consulta_corredor();
          this.$Progress.finish();
        })
        .catch((error) => {
          this.$Progress.finish();
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    consulta_contratante: function(){
      this.$Progress.start();

      return apiGestionVentas
        .consulta_contratante(
          this.$session.get("mail"),
          this.datosFormulario.contratante
        ).then((response) => {

         response.data = this.keysMinuscula(response.data);
         var InfoContratante = response.data.res;

         for (var i = 0; i < InfoContratante.length; i++) {
            this.datosFormulario.IdNacionAse = InfoContratante[i]["peridnacion"];
            this.datosFormulario.NombreAseg  = InfoContratante[i]["pernombreimp"];
          }
        this.$Progress.finish();
        })
        .catch((error) => {
          this.$Progress.finish();
          this.crearNotificacion("Error de sistema", error, "error");          
        });
    },

    consulta_corredor: function(){
      this.$Progress.start();

      return apiGestionVentas
        .consulta_corredor(
          this.$session.get("mail"),
          this.datosFormulario.corredor
        ).then((response) => {

         response.data = this.keysMinuscula(response.data);
         var InfoCorredor = response.data.res;
         for (var i = 0; i < InfoCorredor.length; i++) {
            this.datosFormulario.IdNacionCorred = InfoCorredor[i]["peridnacion"];
            this.datosFormulario.NombreCorred = InfoCorredor[i]["pernombreimp"];
          }
        this.$Progress.finish();
        })
        .catch((error) => {
          this.$Progress.finish();
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    actualizaEjecutivoObs: function(){
      this.$Progress.start();
      return apiGestionVentas
        .actualiza_eje_pri_cto(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormularioModal.poliza,
          this.datosFormularioModal.ejecutivo_1er,
          this.datosFormularioModal.ejecutivo_cierre,
          this.datosFormularioModal.observacion,
          this.datosFormularioModal.relacionada
        )
        .then((response) => {

          console.log(this.datosFormularioModal.observacion);
          console.log(this.datosFormularioModal.poliza);
          
          response.data = this.keysMinuscula(response.data);
          if (response.data.festado.resultado.estado == "error"){
            this.mostrarErroresEnFormulario(response.data.festado);

          }
          else{
              this.$Progress.finish();
              this.buscar();
              this.crearNotificacion(
                "Atención",
                "Actualizado con exito",
                "success"
              );

          }
          this.$Progress.finish();
        });

    }

  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },

  watch: {
    pagina: function (nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.card-header {
  background-color: #00a7d4;
  color: #fff;
}

.multiselect__tag {
  background: #20a8d8 !important;
}
.multiselect__option--highlight:after {
  background: #20a8d8 !important;
}

.multiselect__option--highlight {
  background: #20a8d8 !important;
}
.multiselect__tags {
  border-radius: 0px !important;
  min-height: 70px !important;
}
/*
.el-button {
  background: #00a7d4;
}*/
</style>

